import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Drawer from './components/Drawer/Drawer';
import Portfolio from './components/Portfolio/Portfolio';
import About from './components/About/About';
import CustomCursor from './components/CustomCursor/CustomCursor';
import Loader from './components/Loader/Loader';
import './App.css';
import './styles/globals.css';
import { preloadAllImages } from './utils/imageLoader';
import Footer from './components/Footer/Footer';
import Contact from './components/Contact/Contact';
function App() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);
  const mainRef = useRef(null);

  // Precargar todas las imágenes
  useEffect(() => {
    preloadAllImages();
  }, []);

  const handleLoaderComplete = () => {
    setIsLoading(false);
    // Pequeño delay para el fade in del contenido
    setTimeout(() => {
      setShowContent(true);
    }, 100);
  };

  const handleDrawerToggle = () => {
    console.log('Drawer toggle clicked, current state:', isDrawerOpen); // Debug
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleDrawerClose = () => {
    console.log('Drawer close called'); // Debug
    setIsDrawerOpen(false);
  };

  if (isLoading) {
    return <Loader onComplete={handleLoaderComplete} />;
  }

  return (
    <Router>
      <div className="App">
        <CustomCursor />
        <Header onMenuToggle={handleDrawerToggle} />
        
        <Drawer 
          isOpen={isDrawerOpen} 
          onClose={handleDrawerClose}
        />
        
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      <Footer></Footer>
      </div>
    </Router>

  );
}

export default App;
